import React from 'react'
import Form from 'react-bootstrap/Form'
import InputGroup from 'react-bootstrap/InputGroup'
import { Typeahead } from 'react-bootstrap-typeahead'
import { useField } from 'formik'
/* eslint-disable prettier/prettier */

const SelectRadioGroup = React.forwardRef((props, ref) => {
  const [field, meta, helper] = useField(props)

  const handleClear = () => {
    helper.setValue('')
    helper.setTouched(false)
    ref.current.clear()
  }

  return (
      
    <Form.Group controlId={`form-${props.name}`}>
      <Form.Label>{props.label}</Form.Label>
      <InputGroup hasValidation>
        <InputGroup.Radio
          name={`check-${props.name}`}
          checked={props.checked || false}
          onChange={props.onFocus ? props.onFocus : () => {}}
        />
        <Typeahead
          ref={ref}
          id={props.name}
          labelKey={props.labelKey}
          options={props.options}
          placeholder='Seleccione'
          onChange={(selected) => {
            if (selected.length > 0) {
              helper.setValue(selected[0].id)
              helper.setTouched(true)
              helper.setError('')
            }
          }}
          onInputChange={(text) => helper.setValue(text)}
          isValid={field.value !== '' && !meta.error && meta.touched}
          {...(!!meta.error && { isInvalid: true, className: 'is-invalid' })}
          {...props}
        />
        <InputGroup.Text onClick={handleClear}>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='16'
            height='16'
            fill='currentColor'
            className='bi bi-x'
            viewBox='0 0 16 16'
          >
            <path d='M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z' />
          </svg>
        </InputGroup.Text>
        <Form.Control.Feedback type='invalid'>
          {' '}
          {meta.error}{' '}
        </Form.Control.Feedback>
      </InputGroup>
    </Form.Group>
  )
})

export default SelectRadioGroup
